import { render, staticRenderFns } from "./AdminChannels.vue?vue&type=template&id=658ddce4&scoped=true&"
import script from "./AdminChannels.ts?vue&type=script&lang=ts&"
export * from "./AdminChannels.ts?vue&type=script&lang=ts&"
import style1 from "./AdminChannels.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658ddce4",
  null
  
)

export default component.exports